import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import * as Styles from './sso-buttons.module.scss';
import Button from './button';
import CleverIcon from '../assets/components/sso-buttons/clever-icon.png';
import GoogleIcon from '../assets/components/sso-buttons/google-icon.png';

function SSOButtons({ className, showClever, showGoogle }) {
  return (
    <div className={classNames(Styles.root, className)}>
      {showClever && (
        <Button
          theme="white"
          size="md"
          type="link"
          action="/sign-in-clever-redirect"
          className={classNames(Styles.clever)}
        >
          <>
            <img src={CleverIcon} width={30} height={30} alt="" className={Styles.icon} />
            Continue with Clever
          </>
        </Button>
      )}
      {showGoogle && (
        <Button theme="white" size="md" type="link" action="/sign-in-google-redirect">
          <>
            <img src={GoogleIcon} width={30} height={30} alt="" className={Styles.icon} />
            Continue with Google
          </>
        </Button>
      )}
    </div>
  );
}

SSOButtons.propTypes = {
  className: PropTypes.string,
  showClever: PropTypes.bool,
  showGoogle: PropTypes.bool,
};

SSOButtons.defaultProps = {
  className: null,
  showClever: true,
  showGoogle: true,
};

export default SSOButtons;
